export default "__VITE_ASSET__WUm3rguc__"